import Main from "@/ts/base/Main";
import debounce from "debounce";

export default class FullscreenElement {
	elems: NodeListOf<HTMLElement>;

	static get Resized(): string {
		return "fullscreen-resized";
	}

	constructor(selector: string) {
		this.elems = document.querySelectorAll(selector);

		if (this.elems.length > 0) {
			window.addEventListener(Main.IsLoadedClass, this.onUpdate.bind(this));
			window.addEventListener("resize", debounce(this.onUpdate.bind(this), 150));
		}
	}

	resize(): void {
		const header = Main.Instance.getHeaderComponent()?.getElement();
		let wh = window.innerHeight;
		if (header) {
			if (window.getComputedStyle(header).position === "sticky") {
				wh -= header.offsetHeight;
			}
		}


		const adminBar = document.getElementById("wpadminbar");
		if (adminBar) {
			wh -= adminBar.clientHeight;
		}

		this.elems.forEach(
			(item) => {
				item.style.minHeight = `${wh}px`;
				item.dispatchEvent(new Event(FullscreenElement.Resized));
			}
		);
	}

	protected onUpdate() {
		this.resize();
	}
}
